import React from "react";
import classes from "./index.module.scss";
import Header from "components/Header";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import classNames from "classnames";

interface BreadLayoutProps {
    children: React.ReactNode;
    breadcrumb: React.ReactNode; //其余面包屑导航
}

export default function BreadLayout({
    children,
    breadcrumb
}: BreadLayoutProps) {
    return (
        <div className={classNames(classes.root, "PopupContainer")}>
            <Header />

            <div className={classes.main}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>
                        <Link to="/" replace>
                            首页
                        </Link>
                    </Breadcrumb.Item>

                    {typeof breadcrumb === "string" ? (
                        <Breadcrumb.Item>{breadcrumb}</Breadcrumb.Item>
                    ) : (
                        breadcrumb
                    )}
                </Breadcrumb>

                <div className={classes.body}>{children}</div>
            </div>
        </div>
    );
}
